/* ===========================================================
   lib/hosts.js — Docs, Notes and Drive each have their own address
   (docs. / notes. / drive.weatherprotocol.org, his ask). On the
   workers.dev address (his home network blocks weatherprotocol.org)
   and on this computer they stay pages: /notes and /drive.
   =========================================================== */

import { go } from './router.js';

const WP = /(^|\.)weatherprotocol\.org$/;
const onWP = () => WP.test(location.hostname);

/** Which app this address is: 'docs' | 'notes' | 'drive'. */
export function hostApp() {
  const sub = location.hostname.split('.')[0];
  return onWP() && (sub === 'notes' || sub === 'drive') ? sub : 'docs';
}

/** Where a page of an app lives, as a link. */
export function appHref(app, path = '/') {
  const p = app === 'docs' ? path : '/';
  if (onWP()) return hostApp() === app ? p : `https://${app}.weatherprotocol.org${p}`;
  return app === 'docs' ? path : `/${app}`;
}

/** Open an app (same tab). */
export function openApp(app, path = '/') {
  const href = appHref(app, path);
  if (href.startsWith('http')) location.href = href;
  else go(href);
}
